import Box from "@mui/material/Box";
import StyledDropdown from "../../CommonComponents/StyledDropdown/StyledDropdown";
import {useTheme} from "../../../contexts/theme";
import {useClipMamSelected} from "../../../contexts/clipMamSelected";
import React, {useCallback, useEffect, useState} from "react";
import StyledPopup from "../../CommonComponents/StyledPopup/StyledPopup";
import {ButtonGroup, Popper, Tooltip, Typography} from "@mui/material";
import TransparentButton from "../../CommonComponents/TransparentButton/TransparentButton";
import CreateIcon from "@mui/icons-material/Create";
import DownloadIcon from "@mui/icons-material/Download";
import DeselectIcon from "@mui/icons-material/Deselect";
import DeleteIcon from "@mui/icons-material/Delete";
import StyledIconButton from "../../CommonComponents/StyledIconButton/StyledIconButton";
import AppsIcon from "@mui/icons-material/Apps";
import TableRowsIcon from "@mui/icons-material/TableRows";
import CustomPopperComponent from "../../CommonComponents/CustomDownloadButton/CustomPopperComponent";
import CustomDownloadButton from "../../CommonComponents/CustomDownloadButton/CustomDownloadButton";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import StyledSnackbar from "../../CommonComponents/StyledSnackbar/StyledSnackbar";

interface MamOptionsProps {

    optionsAspectRatio?: string[];
    handleCreateHighlight: () => void;
    disableHighlightButton: boolean;
    handleDeselectClip:() => void;
    handleDeleteClip:() => void;
    handleChangeView: (view: "table" | "cards") => void;
    handleOpenCreateAggregation: () => void;
}


const needButtonBackground = process.env.REACT_APP_SPORT === 'basketball'

export default function MamOptions({optionsAspectRatio, handleCreateHighlight, disableHighlightButton, handleDeselectClip, handleOpenCreateAggregation, handleDeleteClip, handleChangeView}: MamOptionsProps) {


    const {aspectRatio, setAspectRatio, clips, deleteAllClips} = useClipMamSelected();


    const [pendingAspectRation, setPendingAspectRation] = useState<string>('');

    const [popup, setPopup] = useState<boolean>(false);
    const [selectedClipsAspectRatio, setSelectedClipsAspectRatio] = useState<string>("16:9");
    const [isClipDownloading, setIsClipDownloading] = React.useState<string>('NODOWNLOAD');

    const handleAspectRatioChange = () => {
        if (clips.length > 0) {
            deleteAllClips();
        }
        setAspectRatio(pendingAspectRation);

        setPopup(false);
    }

    useEffect(() => {
        if(clips.length > 0) {
            setSelectedClipsAspectRatio(clips[0].aspect_ratio)
        }
    }, [clips]);



    const theme = useTheme();

    return (
        <Box>

            <StyledSnackbar
                open={isClipDownloading === 'DOWNLOAD'}
                setClose={() => setIsClipDownloading('NODOWNLOAD')}
                message={'Wait for your download'}
                severity={'info'}
                closeButton={true}
            />
            <StyledSnackbar
                open={isClipDownloading === 'FAILED'}
                setClose={() => setIsClipDownloading('NODOWNLOAD')}
                message={'Error to download your clip'}
                severity={'error'}
                closeButton={true}
            />

          <StyledPopup width={'30%'} height={'20%'}  isOpen={popup} onClose={() => {setPopup(prevState => !prevState)}}>
                <Box>

                    <Typography variant="h6" color={theme.palette.white} align={'center'}>
                        If you change the format, you will lose the clip selection, do you want to proceed?
                    </Typography>
                    <Box sx={{display: "flex", justifyContent: "space-around", paddingTop: theme.spacing.md }}>
                   <TransparentButton text={"Yes"} width={'40%'} onClick={()=>{handleAspectRatioChange()}} ></TransparentButton>
                    <TransparentButton text={"No"} width={'40%'}  onClick={()=>{setPopup(false)}}></TransparentButton>
                    </Box>

                </Box>
          </StyledPopup>

            {optionsAspectRatio && (
                <StyledDropdown  needButtonBackground={needButtonBackground} options={optionsAspectRatio} label={'Highlight aspect ratio'} value={aspectRatio}  id={'aspectRatioSelect'} borderRadius={theme.border.radius.md} onChange={(event) => {

                    if (clips.length === 0)
                        setAspectRatio(event.target.value);
                    else {
                        setPendingAspectRation(event.target.value);
                        setPopup(true);
                    }
                }}/>
            )}

            <CustomDownloadButton
                selectedClipsAspectRatio={selectedClipsAspectRatio}
                marginLeft={theme.spacing.md}
                height="100%"
                text="Download"
                additionalComponent={
                    <ArrowDropDownIcon sx={{ color: 'white' }} />
                }
                setIsClipDownloading={setIsClipDownloading}
                clips={clips}
                isProductionNeeded={false}
            />
            { /*
            <TransparentButton
                height="100%"
                onClick={() => {handleOpenCreateAggregation()}}
                marginLeft={theme.spacing.md}
                text="Create Aggregate"
                icon={
                    <DeleteIcon
                        sx={{
                            color: !disableHighlightButton
                                ? theme.palette.white
                                : theme.palette.lightGrey
                        }}
                    />
                }
                needBackground={needButtonBackground}
            /> */
            }

            <TransparentButton
                height="100%"
                onClick={() => {handleDeleteClip()}}
                marginLeft={theme.spacing.md}
                text="Delete"
                disabled={!disableHighlightButton}
                icon={
                    <DeleteIcon
                        sx={{
                            color: !disableHighlightButton
                                ? theme.palette.white
                                : theme.palette.lightGrey
                        }}
                    />
                }
                needBackground={needButtonBackground}
            />

                <TransparentButton
                    height="100%"
                    onClick={handleCreateHighlight}
                    text="Create highlight"
                    marginLeft={theme.spacing.md}
                    disabled={!disableHighlightButton}
                    icon={
                        <CreateIcon
                            sx={{
                                color: !disableHighlightButton
                                    ? theme.palette.white
                                    : theme.palette.lightGrey
                            }}
                        />
                    }
                    needBackground={needButtonBackground}
                />

            <TransparentButton
                height="100%"
                marginLeft={theme.spacing.md}
                onClick={() => {
                 handleDeselectClip()
                }}
                text="Deselect all"
                disabled={!disableHighlightButton}
                icon={
                    <DeselectIcon
                        sx={{
                            color: !disableHighlightButton
                                ? theme.palette.white
                                : theme.palette.lightGrey
                        }}
                    />
                }
                needBackground={needButtonBackground}
            />


                <ButtonGroup sx={{height: '100%', flex: 1}}>
                    <Box sx={{marginRight: theme.spacing.md, marginLeft: theme.spacing.md}}>
                        <StyledIconButton height={'100%'}
                                          onClick={() => {handleChangeView('cards')}}
                        >
                            <AppsIcon sx={{ color: theme.palette.lightGrey }} />
                        </StyledIconButton>
                    </Box>
                    <Box>
                        <StyledIconButton height={'100%'}
                                          onClick={() => {handleChangeView('table')}}
                        >
                            <TableRowsIcon sx={{ color: theme.palette.lightGrey }} />
                        </StyledIconButton>
                    </Box>
                </ButtonGroup>
            </Box>


    );

}

